import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { modalPropTypes } from 'components/Modals';
import ModalContainer from 'components/modals/ModalContainer';
import { getScenario } from 'actions/asyncActions';
import ScenarioInfo from 'components/views/education/scenario/ScenarioInfo';

@connect((state) => ({ scenario: getScenario.selectData(state) }))
export default class ScenarioModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        scenario: PropTypes.object.isRequired,
    }

    render() {
        const { modal, scenario: { object = {} }, scenario } = this.props;

        return (
            <ModalContainer
                meta={{}}
                modal={modal}
                title={object.name}
                className="modal-full card-modal scenario-modal">
                <ScenarioInfo info={scenario} />
            </ModalContainer>
        )
    }
}
